// extracted by mini-css-extract-plugin
export default {"separator":"+asyk9P0LpA0iQYLMdY4lQ=="};